var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"login-head"},[_c('li',{class:{ 'active': !_vm.isRegisterTab },on:{"click":_vm.toLogin}},[_vm._v("登录")]),_c('li',{class:{ 'active': _vm.isRegisterTab },on:{"click":_vm.toRegister}},[_vm._v("注册")])])}
var staticRenderFns = []

export { render, staticRenderFns }